import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@components/buttons";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { observer } from "mobx-react";

export default observer(function ModalFooter(props: { store: CashoutStore }) {
	const t = useTranslation().t;

	const [shouldSaveButtonBeDisabled, setShouldSaveButtonBeDisabled] =
		useState<boolean>(false);

	const openedAutosellModalBetSlipId =
		props.store.openedAutosellModalBetSlipId;

	if (props.store.isAutosellModalCashedOut) {
		return (
			<button
				type="button"
				className="popup__btn btn btn--med btn--primary--inverted"
				onClick={props.store.closeAutosellModal}
			>
				{t("COMMON.CLOSE")}
			</button>
		);
	} else if (props.store.isAutocashoutUnavailable) {
		if (openedAutosellModalBetSlipId == null) {
			console.error("Expected cashout modal, got null.");
			return null;
		}

		return (
			<>
				{props.store.isConfigurationExists && (
					<div className="popup__footer__left">
						<button
							type="button"
							className="popup__btn btn btn--med btn--primary--inverted u-color--sent--danger"
							disabled
						>
							{t("COMMON.DELETE")}
						</button>
					</div>
				)}

				<div className="popup__footer__right">
					<button
						type="button"
						className="popup__btn btn btn--med btn--primary--inverted"
						onClick={props.store.closeAutosellModal}
					>
						{t("COMMON.CLOSE")}
					</button>

					<Button
						type="button"
						className="popup__btn btn btn--med btn--accent u-mar--left--tny"
						onClick={async () => {
							await props.store.setSecureWinConfiguration(
								openedAutosellModalBetSlipId,
								Number(props.store.secureWinAmount)
							);
						}}
						disabled={props.store.isSaveBtnDisabled}
						btnText={t("COMMON.SAVE")}
					></Button>
				</div>
			</>
		);
	} else {
		if (openedAutosellModalBetSlipId == null) {
			console.error("Expected cashout modal, got null.");
			return null;
		}
		return (
			<>
				{props.store.isConfigurationExists && (
					<div className="popup__footer__left">
						<Button
							type="button"
							className="popup__btn btn btn--med btn--primary--inverted u-color--sent--danger"
							onClick={async () => {
								await props.store.removeSecureWinConfiguration(
									openedAutosellModalBetSlipId
								);
							}}
							btnText={t("COMMON.DELETE")}
						></Button>
					</div>
				)}

				<div className="popup__footer__right">
					<button
						type="button"
						className="popup__btn btn btn--med btn--primary--inverted"
						onClick={props.store.closeAutosellModal}
					>
						{t("COMMON.CANCEL")}
					</button>

					<Button
						type="button"
						className="popup__btn btn btn--med btn--accent u-mar--left--tny"
						onClick={async () => {
							setShouldSaveButtonBeDisabled(true);
							await props.store.setSecureWinConfiguration(
								openedAutosellModalBetSlipId,
								Number(props.store.secureWinAmount)
							);
							setShouldSaveButtonBeDisabled(false);
						}}
						disabled={
							props.store.isSaveBtnDisabled ||
							shouldSaveButtonBeDisabled
						}
						btnText={t("COMMON.SAVE")}
					></Button>
				</div>
			</>
		);
	}
});
